import { Component } from '@angular/core';
import { ContentContainerButtonGroup } from 'src/app/components/_design-components/content-container/content-container.component';

@Component({
  selector: 'app-manage-staff',
  templateUrl: './manage-staff.component.html',
  styleUrls: ['./manage-staff.component.scss'],
})
export class ManageStaffComponent {
  contentNavOptions: ContentContainerButtonGroup[] = [
    { display: 'Staff List', name: 'Staff List' },
    { display: 'Reassign Staff', name: 'Reassign Staff' },
  ];
  selectedTab = this.contentNavOptions[0].name;

  constructor() {}

  onNavClicked(navName: string) {
    this.selectedTab = navName;
  }
}
